import * as Immutable from 'immutable';

export const licenses = Immutable.fromJS([
    {
        licenses: 'MIT',
        repository: 'https://www.github.com/DefinitelyTyped/DefinitelyTyped',
        version: '0.7.7',
        licenseFile: 'https://www.github.com/DefinitelyTyped/DefinitelyTyped/blob/master/LICENSE',
        name: '@types/hls.js',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/squaremo/amqp.node',
        publisher: 'Michael Bridgen',
        email: 'mikeb@squaremobius.net',
        version: '0.5.1',
        licenseFile: 'https://github.com/squaremo/amqp.node/blob/master/LICENSE',
        name: 'amqplib',
    },
    {
        licenses: 'MPL-2.0',
        repository: 'https://github.com/shoreditch-ops/artillery',
        publisher: 'Hassy Veldstra',
        email: 'h@veldstra.org',
        version: '1.5.6',
        licenseFile: 'https://github.com/shoreditch-ops/artillery/blob/master/LICENSE.txt',
        name: 'artillery',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/bubkoo/ascii-progress',
        publisher: 'bubkoo',
        email: 'bubkoo.wy@gmail.com',
        version: '1.0.5',
        licenseFile: 'https://github.com/bubkoo/ascii-progress/blob/master/LICENSE',
        name: 'ascii-progress',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/postcss/autoprefixer',
        publisher: 'Andrey Sitnik',
        email: 'andrey@sitnik.ru',
        version: '6.5.3',
        licenseFile: 'https://github.com/postcss/autoprefixer/blob/master/LICENSE',
        name: 'autoprefixer',
    },
    {
        repository: 'https://github.com/aws/aws-sdk-js',
        name: 'aws-sdk',
        url: 'http://aws.amazon.com/',
        licenses: 'Apache-2.0',
        noticeFile: '/Users/jimmy/Sites/meteor-x/meteor-server/node_modules/aws-sdk/NOTICE.txt',
        version: '2.94.0',
        publisher: 'Amazon Web Services',
        licenseFile: 'https://github.com/aws/aws-sdk-js/blob/master/LICENSE.txt',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/mzabriskie/axios',
        publisher: 'Matt Zabriskie',
        version: '0.25.0',
        licenseFile: 'https://github.com/mzabriskie/axios/blob/master/LICENSE',
        name: 'axios',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-cli',
        publisher: 'Sebastian McKenzie',
        email: 'sebmck@gmail.com',
        version: '6.22.2',
        licenseFile: 'https://github.com/babel/babel/tree/master/packages/babel-cli/blob/master/README.md',
        name: 'babel-cli',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-core',
        publisher: 'Sebastian McKenzie',
        email: 'sebmck@gmail.com',
        version: '6.22.1',
        licenseFile: 'https://github.com/babel/babel/tree/master/packages/babel-core/blob/master/README.md',
        name: 'babel-core',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel-eslint',
        publisher: 'Sebastian McKenzie',
        email: 'sebmck@gmail.com',
        version: '7.2.1',
        licenseFile: 'https://github.com/babel/babel-eslint/blob/master/LICENSE',
        name: 'babel-eslint',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel-loader',
        publisher: 'Luis Couto',
        email: 'hello@luiscouto.pt',
        version: '6.2.9',
        licenseFile: 'https://github.com/babel/babel-loader/blob/master/LICENSE',
        name: 'babel-loader',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-plugin-external-helpers',
        version: '6.4.0',
        licenseFile:
            'https://github.com/babel/babel/tree/master/packages/babel-plugin-external-helpers/blob/master/README.md',
        name: 'babel-plugin-external-helpers',
    },
    {
        repository: 'https://github.com/lodash/babel-plugin-lodash',
        name: 'babel-plugin-lodash',
        url: 'https://github.com/megawac',
        licenses: 'MIT',
        version: '3.2.10',
        publisher: 'Graeme Yeates',
        email: 'megawac@gmail.com',
        licenseFile: 'https://github.com/lodash/babel-plugin-lodash/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel-plugins/babel-plugin-object-assign',
        publisher: 'Jed Watson',
        version: '1.2.1',
        licenseFile: 'https://github.com/babel-plugins/babel-plugin-object-assign/blob/master/LICENSE',
        name: 'babel-plugin-object-assign',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/yahoo/babel-plugin-react-intl',
        publisher: 'Eric Ferraiuolo',
        email: 'edf@ericf.me',
        version: '2.0.0',
        licenseFile: 'https://github.com/yahoo/babel-plugin-react-intl/blob/master/LICENSE',
        name: 'babel-plugin-react-intl',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/gaearon/babel-plugin-react-transform',
        publisher: 'Dan Abramov',
        email: 'dan.abramov@me.com',
        version: '2.0.0',
        licenseFile: 'https://github.com/gaearon/babel-plugin-react-transform/blob/master/README.md',
        name: 'babel-plugin-react-transform',
    },
    {
        licenses: 'ISC',
        repository: 'https://github.com/speedskater/babel-plugin-rewire',
        publisher: 'r.binna@synedra.com',
        version: '1.1.0',
        licenseFile: 'https://github.com/speedskater/babel-plugin-rewire/blob/master/README.md',
        name: 'babel-plugin-rewire',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-decorators',
        version: '6.3.13',
        licenseFile:
            'https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-decorators/blob/master/README.md',
        name: 'babel-plugin-syntax-decorators',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/loganfsmyth/babel-plugin-transform-builtin-extend',
        publisher: 'Logan Smyth',
        email: 'loganfsmyth@gmail.com',
        version: '1.1.2',
        licenseFile: 'https://github.com/loganfsmyth/babel-plugin-transform-builtin-extend/blob/master/LICENSE',
        name: 'babel-plugin-transform-builtin-extend',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-decorators',
        version: '6.4.0',
        licenseFile:
            'https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-decorators/blob/master/README.md',
        name: 'babel-plugin-transform-decorators',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/loganfsmyth/babel-plugin-transform-decorators-legacy',
        publisher: 'Logan Smyth',
        email: 'loganfsmyth@gmail.com',
        version: '1.3.4',
        licenseFile: 'https://github.com/loganfsmyth/babel-plugin-transform-decorators-legacy/blob/master/LICENSE',
        name: 'babel-plugin-transform-decorators-legacy',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-regenerator',
        publisher: 'Ben Newman',
        email: 'bn@cs.stanford.edu',
        version: '6.24.1',
        licenseFile:
            'https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-regenerator/blob/master/README.md',
        name: 'babel-plugin-transform-regenerator',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-runtime',
        version: '6.4.3',
        licenseFile:
            'https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-runtime/blob/master/README.md',
        name: 'babel-plugin-transform-runtime',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-polyfill',
        publisher: 'Sebastian McKenzie',
        email: 'sebmck@gmail.com',
        version: '6.23.0',
        licenseFile: 'https://github.com/babel/babel/tree/master/packages/babel-polyfill/blob/master/README.md',
        name: 'babel-polyfill',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-preset-es2015',
        publisher: 'Sebastian McKenzie',
        email: 'sebmck@gmail.com',
        version: '6.24.1',
        licenseFile: 'https://github.com/babel/babel/tree/master/packages/babel-preset-es2015/blob/master/README.md',
        name: 'babel-preset-es2015',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-preset-react',
        publisher: 'Sebastian McKenzie',
        email: 'sebmck@gmail.com',
        version: '6.16.0',
        licenseFile: 'https://github.com/babel/babel/tree/master/packages/babel-preset-react/blob/master/README.md',
        name: 'babel-preset-react',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-preset-stage-0',
        publisher: 'Sebastian McKenzie',
        email: 'sebmck@gmail.com',
        version: '6.24.1',
        licenseFile: 'https://github.com/babel/babel/tree/master/packages/babel-preset-stage-0/blob/master/README.md',
        name: 'babel-preset-stage-0',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-register',
        publisher: 'Sebastian McKenzie',
        email: 'sebmck@gmail.com',
        version: '6.24.1',
        licenseFile: 'https://github.com/babel/babel/tree/master/packages/babel-register/blob/master/README.md',
        name: 'babel-register',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/babel/babel/tree/master/packages/babel-runtime',
        publisher: 'Sebastian McKenzie',
        email: 'sebmck@gmail.com',
        version: '6.18.0',
        licenseFile: 'https://github.com/babel/babel/tree/master/packages/babel-runtime/blob/master/README.md',
        name: 'babel-runtime',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/kelektiv/node.bcrypt.js',
        publisher: 'Nick Campbell',
        url: 'https://github.com/ncb000gt',
        version: '1.0.1',
        licenseFile: 'https://github.com/kelektiv/node.bcrypt.js/blob/master/LICENSE',
        name: 'bcrypt',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/expressjs/body-parser',
        version: '1.14.2',
        licenseFile: 'https://github.com/expressjs/body-parser/blob/master/LICENSE',
        name: 'body-parser',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/boom',
        version: '4.2.0',
        licenseFile: 'https://github.com/hapijs/boom/blob/master/LICENSE',
        name: 'boom',
    },
    {
        repository: 'https://github.com/trentm/node-bunyan',
        name: 'bunyan',
        url: 'http://trentm.com',
        licenses: 'MIT',
        version: '1.8.12',
        publisher: 'Trent Mick',
        email: 'trentm@gmail.com',
        licenseFile: 'https://github.com/trentm/node-bunyan/blob/master/LICENSE.txt',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/chaijs/chai',
        publisher: 'Jake Luer',
        email: 'jake@alogicalparadox.com',
        version: '3.5.0',
        licenseFile: 'https://github.com/chaijs/chai/blob/master/README.md',
        name: 'chai',
    },
    {
        repository: 'https://github.com/domenic/chai-as-promised',
        name: 'chai-as-promised',
        url: 'https://domenic.me',
        licenses: 'WTFPL',
        version: '7.1.1',
        publisher: 'Domenic Denicola',
        email: 'd@domenic.me',
        licenseFile: 'https://github.com/domenic/chai-as-promised/blob/master/LICENSE.txt',
    },
    {
        repository: 'https://github.com/logicalparadox/chai-spies',
        name: 'chai-spies',
        url: 'http://alogicalparadox.com',
        licenses: 'MIT*',
        version: '0.7.1',
        publisher: 'Jake Luer',
        email: 'jake@alogicalparadox.com',
        licenseFile: 'https://github.com/logicalparadox/chai-spies/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/JedWatson/classnames',
        publisher: 'Jed Watson',
        version: '2.2.5',
        licenseFile: 'https://github.com/JedWatson/classnames/blob/master/LICENSE',
        name: 'classnames',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/dcodeIO/colour.js',
        publisher: 'Daniel Wirtz',
        email: 'dcode@dcode.io',
        version: '0.7.1',
        licenseFile: 'https://github.com/dcodeIO/colour.js/blob/master/LICENSE',
        name: 'colour',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/lorenwest/node-config',
        publisher: 'Loren West',
        email: 'open_source@lorenwest.com',
        version: '1.25.1',
        licenseFile: 'https://github.com/lorenwest/node-config/blob/master/LICENSE',
        name: 'config',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/jshttp/cookie',
        publisher: 'Roman Shtylman',
        email: 'shtylman@gmail.com',
        version: '0.3.1',
        licenseFile: 'https://github.com/jshttp/cookie/blob/master/LICENSE',
        name: 'cookie',
    },
    {
        repository: 'https://github.com/sindresorhus/cpy-cli',
        name: 'cpy-cli',
        url: 'sindresorhus.com',
        licenses: 'MIT',
        version: '1.0.1',
        publisher: 'Sindre Sorhus',
        email: 'sindresorhus@gmail.com',
        licenseFile: 'https://github.com/sindresorhus/cpy-cli/blob/master/license',
    },
    {
        repository: 'https://github.com/kentcdodds/cross-env',
        name: 'cross-env',
        url: 'http://kentcdodds.com/',
        licenses: 'MIT',
        version: '3.2.3',
        publisher: 'Kent C. Dodds',
        email: 'kent@doddsfamily.us',
        licenseFile: 'https://github.com/kentcdodds/cross-env/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/css-loader',
        publisher: 'Tobias Koppers @sokra',
        version: '0.26.1',
        licenseFile: 'https://github.com/webpack/css-loader/blob/master/README.md',
        name: 'css-loader',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/mbostock/d3',
        publisher: 'Mike Bostock',
        url: 'http://bost.ocks.org/mike',
        version: '3.5.14',
        licenseFile: 'https://github.com/mbostock/d3/blob/master/LICENSE',
        name: 'd3',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/visionmedia/debug',
        publisher: 'TJ Holowaychuk',
        email: 'tj@vision-media.ca',
        version: '2.2.0',
        licenseFile: 'https://github.com/visionmedia/debug/blob/master/Readme.md',
        name: 'debug',
    },
    {
        licenses: 'MIT*',
        repository: 'https://github.com/mickhansen/dottie.js',
        publisher: 'Mick Hansen',
        email: 'maker@mhansen.io',
        version: '1.1.1',
        licenseFile: 'https://github.com/mickhansen/dottie.js/blob/master/LICENSE',
        name: 'dottie',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/CascadeEnergy/dynamoDb-marshaler',
        version: '2.0.0',
        licenseFile: 'https://github.com/CascadeEnergy/dynamoDb-marshaler/blob/master/LICENSE',
        name: 'dynamodb-marshaler',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/stefanpenner/es6-promise',
        publisher: 'Yehuda Katz, Tom Dale, Stefan Penner and contributors',
        url: 'Conversion to ES6 API by Jake Archibald',
        version: '4.0.5',
        licenseFile: 'https://github.com/stefanpenner/es6-promise/blob/master/LICENSE',
        name: 'es6-promise',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/digitaldesignlabs/es6-promisify',
        publisher: 'Mike Hall',
        email: 'mikehall314@gmail.com',
        version: '5.0.0',
        licenseFile: 'https://github.com/digitaldesignlabs/es6-promisify/blob/master/README.md',
        name: 'es6-promisify',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/eslint/eslint',
        publisher: 'Nicholas C. Zakas',
        email: 'nicholas+npm@nczconsulting.com',
        version: '3.2.2',
        licenseFile: 'https://github.com/eslint/eslint/blob/master/LICENSE',
        name: 'eslint',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/MoOx/eslint-loader',
        publisher: 'Maxime Thirouin',
        version: '1.6.1',
        licenseFile: 'https://github.com/MoOx/eslint-loader/blob/master/LICENSE',
        name: 'eslint-loader',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/yannickcr/eslint-plugin-react',
        publisher: 'Yannick Croissant',
        email: 'yannick.croissant+npm@gmail.com',
        version: '5.0.1',
        licenseFile: 'https://github.com/yannickcr/eslint-plugin-react/blob/master/LICENSE',
        name: 'eslint-plugin-react',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/guyonroche/exceljs',
        publisher: 'Guyon Roche',
        version: '0.2.37',
        licenseFile: 'https://github.com/guyonroche/exceljs/blob/master/LICENSE',
        name: 'exceljs',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/expose-loader',
        publisher: 'Tobias Koppers @sokra',
        version: '0.7.1',
        licenseFile: 'https://github.com/webpack/expose-loader/blob/master/README.md',
        name: 'expose-loader',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/expressjs/express',
        publisher: 'TJ Holowaychuk',
        email: 'tj@vision-media.ca',
        version: '4.13.4',
        licenseFile: 'https://github.com/expressjs/express/blob/master/LICENSE',
        name: 'express',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/davidmarkclements/fast-safe-stringify',
        publisher: 'David Mark Clements',
        version: '1.1.6',
        licenseFile: 'https://github.com/davidmarkclements/fast-safe-stringify/blob/master/LICENSE',
        name: 'fast-safe-stringify',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/file-loader',
        publisher: 'Tobias Koppers @sokra',
        version: '0.8.5',
        licenseFile: 'https://github.com/webpack/file-loader/blob/master/README.md',
        name: 'file-loader',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/kaesetoast/find-in-files',
        publisher: 'Philipp Nowinski',
        email: 'philipp@nowinski.de',
        version: '0.4.0',
        licenseFile: 'https://github.com/kaesetoast/find-in-files/blob/master/LICENSE',
        name: 'find-in-files',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/shinnn/fs-readfile-promise',
        publisher: 'Shinnosuke Watanabe',
        url: 'https://github.com/shinnn',
        version: '3.0.0',
        licenseFile: 'https://github.com/shinnn/fs-readfile-promise/blob/master/LICENSE',
        name: 'fs-readfile-promise',
    },
    {
        repository: 'https://github.com/mattyork/fuzzy',
        name: 'fuzzy',
        url: 'mattyork.org',
        licenses: 'MIT',
        version: '0.1.3',
        publisher: 'Matt York',
        email: 'york.matt@gmail.com',
        licenseFile: 'https://github.com/mattyork/fuzzy/blob/master/README.md',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/bubkoo/get-cursor-position',
        publisher: 'bubkoo',
        email: 'bubkoo.wy@gmail.com',
        version: '1.0.3',
        licenseFile: 'https://github.com/bubkoo/get-cursor-position/blob/master/LICENSE',
        name: 'get-cursor-position',
    },
    {
        repository: 'https://github.com/isaacs/node-glob',
        name: 'glob',
        url: 'http://blog.izs.me/',
        licenses: 'ISC',
        version: '7.0.3',
        publisher: 'Isaac Z. Schlueter',
        email: 'i@izs.me',
        licenseFile: 'https://github.com/isaacs/node-glob/blob/master/LICENSE',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/glue',
        version: '4.1.0',
        licenseFile: 'https://github.com/hapijs/glue/blob/master/LICENSE',
        name: 'glue',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/good',
        version: '7.1.0',
        licenseFile: 'https://github.com/hapijs/good/blob/master/LICENSE',
        name: 'good',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/good-console',
        version: '6.2.0',
        licenseFile: 'https://github.com/hapijs/good-console/blob/master/LICENSE',
        name: 'good-console',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/good-squeeze',
        version: '5.0.1',
        licenseFile: 'https://github.com/hapijs/good-squeeze/blob/master/LICENSE',
        name: 'good-squeeze',
    },
    {
        licenses: 'Apache-2.0',
        repository: 'https://github.com/google/google-api-nodejs-client',
        publisher: 'Google Inc.',
        version: '14.2.0',
        licenseFile: 'https://github.com/google/google-api-nodejs-client/blob/master/COPYING',
        name: 'googleapis',
    },
    {
        repository: 'git+https://git.coolaj86.com/coolaj86/greenlock.js',
        name: 'greenlock',
        url: 'https://coolaj86.com/',
        licenses: '(MIT OR Apache-2.0)',
        version: '2.1.17',
        publisher: 'AJ ONeal',
        email: 'coolaj86@gmail.com',
        licenseFile: 'git+https://git.coolaj86.com/coolaj86/greenlock.js/blob/master/LICENSE',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/hapi',
        version: '16.1.0',
        licenseFile: 'https://github.com/hapijs/hapi/blob/master/LICENSE',
        name: 'hapi',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/sibartlett/hapi-io',
        publisher: 'Simon Bartlett',
        email: 'simon@sibartlett.com',
        version: '0.1.0',
        licenseFile: 'https://github.com/sibartlett/hapi-io/blob/master/LICENSE',
        name: 'hapi-io',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/glennjones/hapi-swagger',
        publisher: 'Glenn Jones',
        version: '7.6.0',
        licenseFile: 'https://github.com/glennjones/hapi-swagger/blob/master/license.txt',
        name: 'hapi-swagger',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/mjackson/history',
        version: '2.1.1',
        licenseFile: 'https://github.com/mjackson/history/blob/master/LICENSE.md',
        name: 'history',
    },
    {
        licenses: 'Apache-2.0',
        repository: 'https://github.com/video-dev/hls.js',
        version: '0.8.5',
        licenseFile: 'https://github.com/video-dev/hls.js/blob/master/LICENSE',
        name: 'hls.js',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/hoek',
        version: '4.1.0',
        licenseFile: 'https://github.com/hapijs/hoek/blob/master/LICENSE',
        name: 'hoek',
    },
    {
        repository: 'https://github.com/ampedandwired/html-webpack-plugin',
        name: 'html-webpack-plugin',
        url: 'https://github.com/ampedandwired',
        licenses: 'MIT',
        version: '2.24.1',
        publisher: 'Charles Blaxland',
        email: 'charles.blaxland@gmail.com',
        licenseFile: 'https://github.com/ampedandwired/html-webpack-plugin/blob/master/LICENSE',
    },
    {
        repository: 'https://github.com/image-size/image-size',
        name: 'image-size',
        url: 'http://netroy.in/',
        licenses: 'MIT',
        version: '0.5.0',
        publisher: 'netroy',
        email: 'aditya@netroy.in',
        licenseFile: 'https://github.com/image-size/image-size/blob/master/LICENSE',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/facebook/immutable-js',
        publisher: 'Lee Byron',
        url: 'https://github.com/leebyron',
        version: '3.8.1',
        licenseFile: 'https://github.com/facebook/immutable-js/blob/master/LICENSE',
        name: 'immutable',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/inert',
        version: '4.1.0',
        licenseFile: 'https://github.com/hapijs/inert/blob/master/LICENSE',
        name: 'inert',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/dreamerslab/node.inflection',
        publisher: 'dreamerslab',
        email: 'ben@dreamerslab.com',
        version: '1.12.0',
        licenseFile: 'https://github.com/dreamerslab/node.inflection/blob/master/Readme.md',
        name: 'inflection',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/sboudrias/Inquirer.js',
        publisher: 'Simon Boudrias',
        email: 'admin@simonboudrias.com',
        version: '3.0.6',
        licenseFile: 'https://github.com/sboudrias/Inquirer.js/blob/master/README.md',
        name: 'inquirer',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/benjamn/install',
        publisher: 'Ben Newman',
        email: 'bn@cs.stanford.edu',
        version: '0.4.2',
        licenseFile: 'https://github.com/benjamn/install/blob/master/LICENSE',
        name: 'install',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/andyearnshaw/Intl.js',
        publisher: 'Andy Earnshaw',
        version: '1.0.1',
        licenseFile: 'https://github.com/andyearnshaw/Intl.js/blob/master/LICENSE.txt',
        name: 'intl',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/yahoo/intl-messageformat-parser',
        publisher: 'Eric Ferraiuolo',
        email: 'eferraiuolo@gmail.com',
        version: '1.2.0',
        licenseFile: 'https://github.com/yahoo/intl-messageformat-parser/blob/master/LICENSE',
        name: 'intl-messageformat-parser',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/zertosh/invariant',
        publisher: 'Andres Suarez',
        email: 'zertosh@gmail.com',
        version: '2.2.0',
        licenseFile: 'https://github.com/zertosh/invariant/blob/master/LICENSE',
        name: 'invariant',
    },
    {
        repository: 'https://github.com/DavidTPate/isip',
        name: 'isipaddress',
        url: 'http://davidtpate.com',
        licenses: 'MIT',
        version: '0.0.2',
        publisher: 'David Pate',
        email: 'me@davidtpate.com',
        licenseFile: 'https://github.com/DavidTPate/isip/blob/master/LICENSE',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/gotwarlost/istanbul',
        publisher: 'Krishnan Anantheswaran',
        email: 'kananthmail-github@yahoo.com',
        version: '1.0.0-alpha.2',
        licenseFile: 'https://github.com/gotwarlost/istanbul/blob/master/LICENSE',
        name: 'istanbul',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/joi',
        version: '10.2.0',
        licenseFile: 'https://github.com/hapijs/joi/blob/master/LICENSE',
        name: 'joi',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/nodeca/js-yaml',
        publisher: 'Vladimir Zapparov',
        email: 'dervus.grim@gmail.com',
        version: '3.6.1',
        licenseFile: 'https://github.com/nodeca/js-yaml/blob/master/LICENSE',
        name: 'js-yaml',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/tmpvar/jsdom',
        version: '22.1.0',
        licenseFile: 'https://github.com/tmpvar/jsdom/blob/master/LICENSE.txt',
        name: 'jsdom',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/json-loader',
        publisher: 'Tobias Koppers @sokra',
        version: '0.5.4',
        licenseFile: 'https://github.com/webpack/json-loader/blob/master/README.md',
        name: 'json-loader',
    },
    {
        licenses: 'MIT',
        repository: 'git+https://bitbucket.org/pellepim/jstimezonedetect',
        publisher: 'Jon Nylander',
        email: 'pellepim@gmail.com',
        version: '1.0.6',
        licenseFile: 'git+https://bitbucket.org/pellepim/jstimezonedetect/blob/master/LICENCE.txt',
        name: 'jstimezonedetect',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/karma-runner/karma',
        publisher: 'Vojta Jína',
        email: 'vojta.jina@gmail.com',
        version: '1.4.0',
        licenseFile: 'https://github.com/karma-runner/karma/blob/master/LICENSE',
        name: 'karma',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/karma-runner/karma-chrome-launcher',
        publisher: 'Vojta Jina',
        email: 'vojta.jina@gmail.com',
        version: '2.0.0',
        licenseFile: 'https://github.com/karma-runner/karma-chrome-launcher/blob/master/LICENSE',
        name: 'karma-chrome-launcher',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/karma-runner/karma-mocha',
        publisher: 'Vojta Jina',
        email: 'vojta.jina@gmail.com',
        version: '1.3.0',
        licenseFile: 'https://github.com/karma-runner/karma-mocha/blob/master/LICENSE',
        name: 'karma-mocha',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/demerzel3/karma-sourcemap-loader',
        publisher: 'Gabriele Genta',
        email: 'gabriele.genta@gmail.com',
        version: '0.3.7',
        licenseFile: 'https://github.com/demerzel3/karma-sourcemap-loader/blob/master/LICENSE',
        name: 'karma-sourcemap-loader',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/mlex/karma-spec-reporter',
        publisher: 'Michael Lex',
        email: 'michael.lex@codecentric.de',
        version: '0.0.26',
        licenseFile: 'https://github.com/mlex/karma-spec-reporter/blob/master/LICENSE',
        name: 'karma-spec-reporter',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/karma-webpack',
        publisher: 'Tobias Koppers @sokra',
        version: '2.0.1',
        licenseFile: 'https://github.com/webpack/karma-webpack/blob/master/LICENSE',
        name: 'karma-webpack',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/tgriesser/knex',
        publisher: 'Tim Griesser',
        url: 'https://github.com/tgriesser',
        version: '0.12.9',
        licenseFile: 'https://github.com/tgriesser/knex/blob/master/LICENSE',
        name: 'knex',
    },
    {
        licenses: 'ISC',
        publisher: 'Maythee Anegboonlap',
        email: 'null@llun.me',
        version: '1.0.3',
        licenseFile: 'undefined/blob/master/readme.md',
        name: 'le-store-s3',
    },
    {
        licenses: 'Apache-2.0',
        repository: 'https://github.com/less/less.js',
        publisher: 'Alexis Sellier',
        email: 'self@cloudhead.net',
        version: '2.5.3',
        licenseFile: 'https://github.com/less/less.js/blob/master/LICENSE',
        name: 'less',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/less-loader',
        publisher: 'Tobias Koppers @sokra',
        version: '2.2.3',
        licenseFile: 'https://github.com/webpack/less-loader/blob/master/LICENSE',
        name: 'less-loader',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/davglass/license-checker',
        publisher: 'Dav Glass',
        email: 'davglass@gmail.com',
        version: '15.0.0',
        licenseFile: 'https://github.com/davglass/license-checker/blob/master/LICENSE',
        name: 'license-checker',
    },
    {
        repository: 'https://github.com/lodash/lodash',
        name: 'lodash',
        url: 'http://allyoucanleet.com/',
        licenses: 'MIT',
        version: '4.6.1',
        publisher: 'John-David Dalton',
        email: 'john.david.dalton@gmail.com',
        licenseFile: 'https://github.com/lodash/lodash/blob/master/LICENSE',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/lout',
        version: '9.0.0',
        licenseFile: 'https://github.com/hapijs/lout/blob/master/LICENSE',
        name: 'lout',
    },
    {
        licenses: 'Apache-2.0',
        repository: 'https://github.com/google/material-design-icons',
        publisher: 'Material Design Authors',
        version: '3.0.1',
        licenseFile: 'https://github.com/google/material-design-icons/blob/master/LICENSE',
        name: 'material-design-icons',
    },
    {
        repository: 'https://github.com/broofa/node-mime',
        name: 'mime',
        url: 'http://github.com/broofa',
        licenses: 'MIT',
        version: '1.3.4',
        publisher: 'Robert Kieffer',
        email: 'robert@broofa.com',
        licenseFile: 'https://github.com/broofa/node-mime/blob/master/LICENSE',
    },
    {
        repository: 'https://github.com/substack/node-mkdirp',
        name: 'mkdirp',
        url: 'http://substack.net',
        licenses: 'MIT',
        version: '0.5.1',
        publisher: 'James Halliday',
        email: 'mail@substack.net',
        licenseFile: 'https://github.com/substack/node-mkdirp/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/mochajs/mocha',
        publisher: 'TJ Holowaychuk',
        email: 'tj@vision-media.ca',
        version: '3.2.0',
        licenseFile: 'https://github.com/mochajs/mocha/blob/master/LICENSE',
        name: 'mocha',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/mocha-loader',
        publisher: 'Tobias Koppers @sokra',
        version: '1.0.0',
        licenseFile: 'https://github.com/webpack/mocha-loader/blob/master/README.md',
        name: 'mocha-loader',
    },
    {
        repository: 'https://github.com/moment/moment',
        name: 'moment',
        url: 'https://github.com/ichernev',
        licenses: 'MIT',
        version: '2.15.2',
        publisher: 'Iskren Ivov Chernev',
        email: 'iskren.chernev@gmail.com',
        licenseFile: 'https://github.com/moment/moment/blob/master/LICENSE',
    },
    {
        repository: 'https://github.com/moment/moment-timezone',
        name: 'moment-timezone',
        url: 'http://timwoodcreates.com/',
        licenses: 'MIT',
        version: '0.5.5',
        publisher: 'Tim Wood',
        email: 'washwithcare@gmail.com',
        licenseFile: 'https://github.com/moment/moment-timezone/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/pillarjs/multiparty',
        publisher: 'Andrew Kelley',
        email: 'superjoe30@gmail.com',
        version: '4.1.3',
        licenseFile: 'https://github.com/pillarjs/multiparty/blob/master/LICENSE',
        name: 'multiparty',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/nightwatchjs/nightwatch',
        publisher: 'Andrei Rusu',
        email: 'andrei@nightwatchjs.org',
        version: '0.9.8',
        licenseFile: 'https://github.com/nightwatchjs/nightwatch/blob/master/LICENSE.md',
        name: 'nightwatch',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/node-nock/nock',
        publisher: 'Pedro Teixeira',
        email: 'pedro.teixeira@gmail.com',
        version: '9.0.2',
        licenseFile: 'https://github.com/node-nock/nock/blob/master/README.md',
        name: 'nock',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/fgnass/node-dev',
        publisher: 'Felix Gnass',
        version: '3.1.1',
        licenseFile: 'https://github.com/fgnass/node-dev/blob/master/LICENSE',
        name: 'node-dev',
    },
    {
        licenses: 'MIT',
        publisher: 'Tobias Koppers @sokra',
        version: '0.5.0',
        licenseFile: 'undefined/blob/master/README.md',
        name: 'node-loader',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/bubkoo/ascii-progress',
        publisher: 'bubkoo',
        email: 'bubkoo.wy@gmail.com',
        version: '1.0.0',
        licenseFile: 'https://github.com/bubkoo/ascii-progress/blob/master/LICENSE',
        name: 'node-progress-bars',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/remy/nodemon',
        publisher: 'Remy Sharp',
        url: 'http://github.com/remy',
        version: '1.8.1',
        licenseFile: 'https://github.com/remy/nodemon/blob/master/README.md',
        name: 'nodemon',
    },
    {
        repository: 'https://github.com/npm/npmlog',
        name: 'npmlog',
        url: 'http://blog.izs.me/',
        licenses: 'ISC',
        version: '4.1.2',
        publisher: 'Isaac Z. Schlueter',
        email: 'i@izs.me',
        licenseFile: 'https://github.com/npm/npmlog/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/null-loader',
        publisher: 'Tobias Koppers @sokra',
        version: '0.1.1',
        licenseFile: 'https://github.com/webpack/null-loader/blob/master/README.md',
        name: 'null-loader',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/jinder/path',
        publisher: 'Joyent',
        url: 'http://www.joyent.com',
        version: '0.12.7',
        licenseFile: 'https://github.com/jinder/path/blob/master/LICENSE',
        name: 'path',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/brianc/node-postgres',
        publisher: 'Brian Carlson',
        email: 'brian.m.carlson@gmail.com',
        version: '7.1.2',
        licenseFile: 'https://github.com/brianc/node-postgres/blob/master/README.md',
        name: 'pg',
    },
    {
        repository: 'https://github.com/scarney81/pg-hstore',
        name: 'pg-hstore',
        url: 'https://github.com/scarney81',
        licenses: 'MIT*',
        version: '2.3.2',
        publisher: 'Seth Carney',
        email: 'scarney81@gmail.com',
        licenseFile: 'https://github.com/scarney81/pg-hstore/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/postcss/postcss-loader',
        publisher: 'Andrey Sitnik',
        email: 'andrey@sitnik.ru',
        version: '1.2.0',
        licenseFile: 'https://github.com/postcss/postcss-loader/blob/master/LICENSE',
        name: 'postcss-loader',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/sebastian-software/postcss-smart-import',
        publisher: 'Sebastian Werner',
        version: '0.6.0',
        licenseFile: 'https://github.com/sebastian-software/postcss-smart-import/blob/master/license',
        name: 'postcss-smart-import',
    },
    {
        licenses: 'CC0-1.0',
        repository: 'https://github.com/jonathantneal/precss',
        publisher: 'Jonathan Neal',
        email: 'jonathantneal@hotmail.com',
        version: '1.4.0',
        licenseFile: 'https://github.com/jonathantneal/precss/blob/master/LICENSE.md',
        name: 'precss',
    },
    {
        repository: 'https://github.com/clessg/progress-bar-webpack-plugin',
        name: 'progress-bar-webpack-plugin',
        url: 'https://github.com/clessg',
        licenses: 'MIT',
        version: '1.9.0',
        publisher: 'Chris Gaudreau',
        email: 'chris@crystala.net',
        licenseFile: 'https://github.com/clessg/progress-bar-webpack-plugin/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/andrewrk/connect-proxy',
        publisher: 'Andrew Kelley',
        version: '0.15.0',
        licenseFile: 'https://github.com/andrewrk/connect-proxy/blob/master/LICENSE',
        name: 'proxy-middleware',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/thlorenz/proxyquire',
        publisher: 'Thorsten Lorenz',
        version: '1.7.10',
        licenseFile: 'https://github.com/thlorenz/proxyquire/blob/master/LICENSE',
        name: 'proxyquire',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/facebook/react',
        version: '15.4.1',
        licenseFile: 'https://github.com/facebook/react/blob/master/LICENSE',
        name: 'react',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/facebook/react',
        version: '15.4.1',
        licenseFile: 'https://github.com/facebook/react/blob/master/LICENSE',
        name: 'react-addons-perf',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/facebook/react',
        version: '15.4.1',
        licenseFile: 'https://github.com/facebook/react/blob/master/LICENSE',
        name: 'react-addons-test-utils',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/nkbt/react-copy-to-clipboard',
        publisher: 'Nik Butenko',
        email: 'nik@butenko.me',
        version: '5.0.1',
        licenseFile: 'https://github.com/nkbt/react-copy-to-clipboard/blob/master/LICENSE',
        name: 'react-copy-to-clipboard',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/gpbl/react-day-picker',
        publisher: 'Giampaolo Bellavite',
        email: 'io@gpbl.org',
        version: '6.2.1',
        licenseFile: 'https://github.com/gpbl/react-day-picker/blob/master/LICENSE',
        name: 'react-day-picker',
    },
    {
        repository: 'https://github.com/gaearon/react-dnd',
        name: 'react-dnd',
        url: 'http://github.com/gaearon',
        licenses: 'MIT',
        version: '2.1.4',
        publisher: 'Dan Abramov',
        email: 'dan.abramov@me.com',
        licenseFile: 'https://github.com/gaearon/react-dnd/blob/master/LICENSE',
    },
    {
        repository: 'https://github.com/gaearon/react-dnd-html5-backend',
        name: 'react-dnd-html5-backend',
        url: 'http://github.com/gaearon',
        licenses: 'MIT',
        version: '2.1.2',
        publisher: 'Dan Abramov',
        email: 'dan.abramov@me.com',
        licenseFile: 'https://github.com/gaearon/react-dnd-html5-backend/blob/master/LICENSE',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/facebook/react',
        version: '15.4.1',
        licenseFile: 'https://github.com/facebook/react/blob/master/LICENSE',
        name: 'react-dom',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/CezaryDanielNowak/React-dotdotdot',
        publisher: 'Cezary Daniel Nowak',
        version: '1.0.16',
        licenseFile: 'https://github.com/CezaryDanielNowak/React-dotdotdot/blob/master/LICENSE',
        name: 'react-dotdotdot',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/yahoo/react-intl',
        publisher: 'Eric Ferraiuolo',
        email: 'edf@ericf.me',
        version: '2.1.1',
        licenseFile: 'https://github.com/yahoo/react-intl/blob/master/LICENSE.md',
        name: 'react-intl',
    },
    {
        repository: 'https://github.com/reactjs/react-redux',
        name: 'react-redux',
        url: 'http://github.com/gaearon',
        licenses: 'MIT',
        version: '4.4.5',
        publisher: 'Dan Abramov',
        email: 'dan.abramov@me.com',
        licenseFile: 'https://github.com/reactjs/react-redux/blob/master/LICENSE.md',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/reactjs/react-router',
        version: '2.4.0',
        licenseFile: 'https://github.com/reactjs/react-router/blob/master/LICENSE.md',
        name: 'react-router',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/reactjs/react-router-redux',
        version: '4.0.5',
        licenseFile: 'https://github.com/reactjs/react-router-redux/blob/master/LICENSE',
        name: 'react-router-redux',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/facebook/react',
        version: '15.4.1',
        licenseFile: 'https://github.com/facebook/react/blob/master/LICENSE',
        name: 'react-test-renderer',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/gaearon/react-transform-hmr',
        publisher: 'Dan Abramov',
        email: 'dan.abramov@me.com',
        version: '1.0.1',
        licenseFile: 'https://github.com/gaearon/react-transform-hmr/blob/master/README.md',
        name: 'react-transform-hmr',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/NodeRedis/node_redis',
        publisher: 'Matt Ranney',
        email: 'mjr@ranney.com',
        version: '2.6.0',
        licenseFile: 'https://github.com/NodeRedis/node_redis/blob/master/LICENSE',
        name: 'redis',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/reactjs/redux',
        version: '3.6.0',
        licenseFile: 'https://github.com/reactjs/redux/blob/master/LICENSE.md',
        name: 'redux',
    },
    {
        repository: 'https://github.com/gaearon/redux-devtools',
        name: 'redux-devtools',
        url: 'http://github.com/gaearon',
        licenses: 'MIT',
        version: '3.2.0',
        publisher: 'Dan Abramov',
        email: 'dan.abramov@me.com',
        licenseFile: 'https://github.com/gaearon/redux-devtools/blob/master/LICENSE.md',
    },
    {
        repository: 'https://github.com/gaearon/redux-devtools-dock-monitor',
        name: 'redux-devtools-dock-monitor',
        url: 'http://github.com/gaearon',
        licenses: 'MIT',
        version: '1.1.1',
        publisher: 'Dan Abramov',
        email: 'dan.abramov@me.com',
        licenseFile: 'https://github.com/gaearon/redux-devtools-dock-monitor/blob/master/LICENSE.md',
    },
    {
        repository: 'https://github.com/gaearon/redux-devtools-log-monitor',
        name: 'redux-devtools-log-monitor',
        url: 'http://github.com/gaearon',
        licenses: 'MIT',
        version: '1.0.11',
        publisher: 'Dan Abramov',
        email: 'dan.abramov@me.com',
        licenseFile: 'https://github.com/gaearon/redux-devtools-log-monitor/blob/master/LICENSE.md',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/fcomb/redux-logger',
        publisher: 'Eugene Rodionov',
        url: 'https://github.com/theaqua',
        version: '2.6.1',
        licenseFile: 'https://github.com/fcomb/redux-logger/blob/master/LICENSE',
        name: 'redux-logger',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/richardscarrott/require-error-handler-webpack-plugin',
        publisher: 'Richard Scarrott',
        email: 'riscarrott@googlemail.com',
        version: '0.0.2',
        licenseFile: 'https://github.com/richardscarrott/require-error-handler-webpack-plugin/blob/master/LICENSE',
        name: 'require-error-handler-webpack-plugin',
    },
    {
        repository: 'https://github.com/isaacs/rimraf',
        name: 'rimraf',
        url: 'http://blog.izs.me/',
        licenses: 'ISC',
        version: '2.6.2',
        publisher: 'Isaac Z. Schlueter',
        email: 'i@izs.me',
        licenseFile: 'https://github.com/isaacs/rimraf/blob/master/LICENSE',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/jkbrzt/rrule',
        version: '2.8.1',
        licenseFile: 'https://github.com/jkbrzt/rrule?tab=License-1-ov-file',
        name: 'rrule',
    },
    {
        licenses: 'Apache-2.0',
        repository: 'https://github.com/ReactiveX/RxJS',
        publisher: 'Ben Lesh',
        email: 'ben@benlesh.com',
        version: '5.4.0',
        licenseFile: 'https://github.com/ReactiveX/RxJS/blob/master/LICENSE.txt',
        name: 'rxjs',
    },
    {
        repository: 'https://github.com/sindresorhus/screenfull.js',
        name: 'screenfull',
        url: 'sindresorhus.com',
        licenses: 'MIT',
        version: '3.0.0',
        publisher: 'Sindre Sorhus',
        email: 'sindresorhus@gmail.com',
        licenseFile: 'https://github.com/sindresorhus/screenfull.js/blob/master/license',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/vvo/selenium-standalone',
        publisher: 'Vincent Voyer',
        email: 'vincent@zeroload.net',
        version: '4.8.0',
        licenseFile: 'https://github.com/vvo/selenium-standalone/blob/master/LICENSE',
        name: 'selenium-standalone',
    },
    {
        licenses: 'ISC',
        repository: 'https://github.com/npm/node-semver',
        version: '5.3.0',
        licenseFile: 'https://github.com/npm/node-semver/blob/master/LICENSE',
        name: 'semver',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/sequelize/sequelize',
        publisher: 'Sascha Depold',
        email: 'sascha@depold.com',
        version: '4.6.0',
        licenseFile: 'https://github.com/sequelize/sequelize/blob/master/LICENSE',
        name: 'sequelize',
    },
    {
        licenses: 'Apache-2.0',
        repository: 'https://github.com/lovell/sharp',
        publisher: 'Lovell Fuller',
        email: 'npm@lovell.info',
        version: '0.15.1',
        licenseFile: 'https://github.com/lovell/sharp/blob/master/LICENSE',
        name: 'sharp',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/shelljs/shelljs',
        publisher: 'Artur Adib',
        email: 'arturadib@gmail.com',
        version: '0.7.8',
        licenseFile: 'https://github.com/shelljs/shelljs/blob/master/LICENSE',
        name: 'shelljs',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/shouldjs/should.js',
        publisher: 'TJ Holowaychuk',
        email: 'tj@vision-media.ca',
        version: '11.1.1',
        licenseFile: 'https://github.com/shouldjs/should.js/blob/master/LICENSE',
        name: 'should',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/cjohansen/Sinon.JS',
        publisher: 'Christian Johansen',
        version: '2.0.0-pre.6',
        licenseFile: 'https://github.com/cjohansen/Sinon.JS/blob/master/LICENSE',
        name: 'sinon',
    },
    {
        repository: 'https://github.com/domenic/sinon-chai',
        name: 'sinon-chai',
        url: 'https://domenic.me/',
        licenses: '(BSD-2-Clause OR WTFPL)',
        version: '2.13.0',
        publisher: 'Domenic Denicola',
        email: 'd@domenic.me',
        licenseFile: 'https://github.com/domenic/sinon-chai/blob/master/LICENSE.txt',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/socketio/socket.io',
        version: '1.5.1',
        licenseFile: 'https://github.com/socketio/socket.io/blob/master/LICENSE',
        name: 'socket.io',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/soundcloud/split-by-name-webpack-plugin',
        publisher: 'SoundCloud, Nick Fisher',
        version: '0.0.3',
        licenseFile: 'https://github.com/soundcloud/split-by-name-webpack-plugin/blob/master/LICENSE.md',
        name: 'split-by-name-webpack-plugin',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/mapbox/node-sqlite3',
        publisher: 'MapBox',
        url: 'https://mapbox.com/',
        version: '3.1.8',
        licenseFile: 'https://github.com/mapbox/node-sqlite3/blob/master/LICENSE',
        name: 'sqlite3',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/juliangruber/stream',
        publisher: 'Julian Gruber',
        email: 'julian@juliangruber.com',
        version: '0.0.2',
        licenseFile: 'https://github.com/juliangruber/stream/blob/master/README.md',
        name: 'stream',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/style-loader',
        publisher: 'Tobias Koppers @sokra',
        version: '0.13.0',
        licenseFile: 'https://github.com/webpack/style-loader/blob/master/README.md',
        name: 'style-loader',
    },
    {
        repository: 'https://github.com/isaacs/node-tar',
        name: 'tar',
        url: 'http://blog.izs.me/',
        licenses: 'ISC',
        version: '2.2.1',
        publisher: 'Isaac Z. Schlueter',
        email: 'i@izs.me',
        licenseFile: 'https://github.com/isaacs/node-tar/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/lxe/unstream',
        publisher: 'Aleksey Smolenchuk',
        email: 'lxe@lxe.co',
        version: '2.0.0',
        licenseFile: 'https://github.com/lxe/unstream/blob/master/LICENSE',
        name: 'unstream',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/url-loader',
        publisher: 'Tobias Koppers @sokra',
        version: '0.5.7',
        licenseFile: 'https://github.com/webpack/url-loader/blob/master/README.md',
        name: 'url-loader',
    },
    {
        repository: 'https://github.com/websockets/utf-8-validate',
        name: 'utf-8-validate',
        url: 'http://2x.io',
        licenses: 'MIT',
        version: '2.0.0',
        publisher: 'Einar Otto Stangvik',
        email: 'einaros@gmail.com',
        licenseFile: 'https://github.com/websockets/utf-8-validate/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/ljharb/util.promisify',
        publisher: 'Jordan Harband',
        email: 'ljharb@gmail.com',
        version: '1.0.0',
        licenseFile: 'https://github.com/ljharb/util.promisify/blob/master/LICENSE',
        name: 'util.promisify',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/shtylman/node-uuid',
        publisher: 'Robert Kieffer',
        email: 'robert@broofa.com',
        version: '3.1.0',
        licenseFile: 'https://github.com/shtylman/node-uuid/blob/master/LICENSE.md',
        name: 'uuid',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/chriso/validator.js',
        publisher: "Chris O'Hara",
        email: 'cohara87@gmail.com',
        version: '4.5.2',
        licenseFile: 'https://github.com/chriso/validator.js/blob/master/LICENSE',
        name: 'validator',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/vision',
        version: '4.1.1',
        licenseFile: 'https://github.com/hapijs/vision/blob/master/LICENSE',
        name: 'vision',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/webpack',
        publisher: 'Tobias Koppers @sokra',
        version: '2.2.0',
        licenseFile: 'https://github.com/webpack/webpack/blob/master/LICENSE',
        name: 'webpack',
    },
    {
        repository: 'https://github.com/kentcdodds/webpack-config-utils',
        name: 'webpack-config-utils',
        url: 'http://kentcdodds.com/',
        licenses: 'MIT',
        version: '2.1.0',
        publisher: 'Kent C. Dodds',
        email: 'kent@doddsfamily.us',
        licenseFile: 'https://github.com/kentcdodds/webpack-config-utils/blob/master/LICENSE',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/webpack-dev-middleware',
        publisher: 'Tobias Koppers @sokra',
        version: '1.8.4',
        licenseFile: 'https://github.com/webpack/webpack-dev-middleware/blob/master/LICENSE',
        name: 'webpack-dev-middleware',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/webpack/webpack-dev-server',
        publisher: 'Tobias Koppers @sokra',
        version: '2.2.0',
        licenseFile: 'https://github.com/webpack/webpack-dev-server/blob/master/LICENSE',
        name: 'webpack-dev-server',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/glenjamin/webpack-hot-middleware',
        publisher: 'Glen Mailer',
        email: 'glen@stainlessed.co.uk',
        version: '2.6.4',
        licenseFile: 'https://github.com/glenjamin/webpack-hot-middleware/blob/master/README.md',
        name: 'webpack-hot-middleware',
    },
    {
        licenses: 'MIT',
        repository: 'https://github.com/winstonjs/winston',
        publisher: 'Charlie Robbins',
        email: 'charlie.robbins@gmail.com',
        version: '2.3.1',
        licenseFile: 'https://github.com/winstonjs/winston/blob/master/LICENSE',
        name: 'winston',
    },
    {
        licenses: 'BSD-3-Clause',
        repository: 'https://github.com/hapijs/wreck',
        version: '8.0.0',
        licenseFile: 'https://github.com/hapijs/wreck/blob/master/LICENSE',
        name: 'wreck',
    },
    {
        repository: 'https://github.com/Leonidas-from-XIV/node-xml2js',
        name: 'xml2js',
        url: 'http://xivilization.net',
        licenses: 'MIT*',
        version: '0.4.19',
        publisher: 'Marek Kubica',
        email: 'marek@xivilization.net',
        licenseFile: 'https://github.com/Leonidas-from-XIV/node-xml2js/blob/master/LICENSE',
    },
    {
        repository: 'https://github.com/bcoe/yargs',
        name: 'yargs',
        url: 'http://CodeTunnel.com',
        licenses: 'MIT',
        version: '7.0.2',
        publisher: 'Alex Ford',
        email: 'Alex.Ford@CodeTunnel.com',
        licenseFile: 'https://github.com/bcoe/yargs/blob/master/LICENSE',
    },
]);
